export default __webpack_public_path__ + "static/media/car-3.ebbec998.svg";